import { render, staticRenderFns } from "./footer-translations.vue?vue&type=template&id=5949783b"
import script from "./footer-translations.vue?vue&type=script&lang=js"
export * from "./footer-translations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports